import { twMerge } from 'tailwind-merge';

import type { TextProps } from '@/_components';
import { Text } from '@/_components';
import { textAlignmentStyle } from '@/_shared';

import type { Align } from './types';

export function CellText({
  className,
  align = 'left',
  ...props
}: TextProps & {
  align?: Align;
}) {
  return (
    <Text
      {...props}
      as="small"
      className={twMerge(`text-c-card-muted truncate text-xs font-normal`, textAlignmentStyle[align], className)}
    />
  );
}
